import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { NavBar, Svg, Icon, IconButton, Dropdown } from '../';
import { Menubar } from 'primereact/menubar';
import { Menu } from 'primereact/menu';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown as DropdownPF } from 'primereact/dropdown';
import { TieredMenu } from 'primereact/tieredmenu';
import BackgroundColor from '../../pages/Colors/BackgroundColor';

function Header({
  children,
  menuOptions,
  isReturnEnabled,
  onClickReturnButton,
  isSticky,
  WhiteLabeling,
  positionMenu,
  setPositionMenu,
  ...props
}): ReactNode {

  const { t } = useTranslation('Header');

  const ocultarBtnAslEBaixar = (memoPositionMenu) => {
    const buttons = ['btnAslViewer', 'btnDownload'];
    buttons.forEach(button => {
      document.getElementById(button).style.display = memoPositionMenu === "1" ? 'none' : '';
    });
  }

  const setStatePositionMenu = (newPositionMenu) => {
    try {
      //      positionMenu = positionMenu === undefined ? window.isMobile() ? 0 : 0 : positionMenu;
      //if (newPositionMenu !== positionMenu)
      setPositionMenu(newPositionMenu);
    } catch (ex) { }
  }

  const getPositionMenu = () => {
    try {
      const memoPositionMenu = localStorage.getItem('positionMenu');
      if (memoPositionMenu) {
        ocultarBtnAslEBaixar(memoPositionMenu);
        const _positionMenu = JSON.parse(memoPositionMenu);
        setStatePositionMenu(_positionMenu);
        return _positionMenu;
      }
    } catch (ex) { }
    return 0;
  }

  const menu = useRef(null);
  const [optionsMenuHeader, setOptionsMenuHeader] = useState([]);
  const autenticado = JSON.parse(sessionStorage.getItem('auth')) !== null;
  const [dialogSobre, setDialogSobre] = useState(false);
  const [dialogConfirmacao, setDialogConfirmacao] = useState(false);
  const [textoMenu, setTextoMenu] = useState('Horizontal');
  const [countMenuPosition, setCountMenuPosition] = useState(getPositionMenu());
  const [acessoViewer] = useState(window.location.href.indexOf("viewer?") > 0);
  const [selectedOptionMobile, setSelectedOptionMobile] = useState(null);

  useEffect(() => {
    if (window.isMobile() === false) {
      if (optionsMenuHeader.length === 0)
        autenticado ? menuAdm() : menuClient();
    }
    startPositionMenu('init');
  }, [optionsMenuHeader])

  const imprimirImagem = () => {
    const paciente = document.getElementById('top-pacienteNome').innerText;
    const exame = document.getElementById('top-exame').innerText;
    const cornerstoneCanvas = document.body.getElementsByClassName('cornerstone-canvas');
    const widthImg = `${cornerstoneCanvas.length > 1 ? (98.9 / 2) : 100}%`;
    let imagens = "";
    var cnt = 0;
    for (let index = 0; index < cornerstoneCanvas.length; index++) {
      if (cornerstoneCanvas[index]) {
        imagens += `<img src="${cornerstoneCanvas[index].toDataURL()}" Width="${widthImg}" /> `;
        cnt++;
        if (cnt == 2) {
          imagens += '<br>';
          cnt = 0;
        }
      }
    }
    var win = window.open('about:blank', "_new");
    win.document.open();
    win.document.write([
      '<html>',
      '   <head>',
      '   <title>Tztion WebViewer</title>',
      '   </head>',
      '   <body onload="window.print()" onafterprint="window.close()">',
      '   </br>',
      `   <strong>${paciente}</strong>`,
      `   ${exame}</br></br>`,
      imagens,
      //`   </br></br><div style="text-align:right">${sessionStorage.getItem('versao')}</div>`,
      '   </body>',
      '</html>'
    ].join(''));
    win.document.close();
  }

  const btnImprimir = {
    title: "Imprimir",
    icon: "print",
    onClick: () => {
      imprimirImagem();
    },
    style: { display: acessoViewer ? '' : 'none' }
  };

  const btnListaExames = {
    title: "Listar Exames",
    icon: "list-bullets",
    onClick: () => {
      window.location.href = window.location.origin;
    }
  };

  const btnPreferencias = {
    title: t('Preferences'),
    icon: "user",
    onClick: () => {
      menuOptions[1].onClick();
    }
  };

  const btnSobre = {
    title: "Sobre",
    icon: "info",
    onClick: () => {
      setDialogSobre(true);
    }
  };

  const menuClient = () => {
    const optionsValue = window.isMobile() === false ? [
      btnImprimir,
      btnPreferencias,
      btnSobre
    ] : [];
    if (optionsValue !== optionsMenuHeader)
      setOptionsMenuHeader(optionsValue);
  }

  const menuAdm = () => {
    let optionsValue = [];
    if (acessoViewer)
      optionsValue.push(btnImprimir, btnListaExames)
    optionsValue.push(btnPreferencias, btnSobre);
    setOptionsMenuHeader(optionsValue);
  }

  const animeMenu = (elDivMenu) => {
    elDivMenu.style.opacity = '0';
    setTimeout(() => {
      elDivMenu.style.opacity = '1';
    }, 500);
  }

  const savePositionMenu = (position) => {
    setStatePositionMenu(position);
    localStorage.setItem('positionMenu', position);
  }

  const startPositionMenu = (start) => {

    if (!isReturnEnabled)
      return;

    try {
      start = start === 'init';

      let countPosition = start ? countMenuPosition : countMenuPosition + 1;

      if (countPosition > 2)
        countPosition = 0;

      if (window.isMobile())
        countPosition = 0;

      setCountMenuPosition(countPosition);
      savePositionMenu(countPosition);

      const elDivMain = document.getElementById('divMain');
      const elMenuContainer = document.getElementById('divMenuContainer');
      const elMenuHorizontal = document.getElementById('menuHorizontal');
      const elMenuVertical = document.getElementById('menuVertical');
      const elDivToolBar = document.getElementById('divToolBar');
      const elDivPanel = document.getElementById('divPanel');

      if (countPosition === 1) {
        elDivMain.classList.add('flex');
        elDivToolBar.classList.remove('flex');
        elMenuContainer.classList.remove('layout-menu-container-b');
        elMenuContainer.classList.remove('layout-menu-container-h');
        elMenuContainer.classList.add('layout-menu-container-v');
        elMenuVertical.append(elMenuContainer);
        elDivPanel.style.height = 'calc(100vh - 70px)';
        elDivPanel.style.transition = 'height 0.5s ease 0s !important';
        setTextoMenu('Vertical');
        animeMenu(elMenuContainer);
        return;
      }

      if (countPosition === 0 || countPosition === 2) {
        elDivMain.classList.remove('flex');
        elDivToolBar.classList.add('flex');
        elMenuContainer.classList.remove('layout-menu-container-v');
        elMenuContainer.style.marginBottom = '10';
        elMenuContainer.classList.remove('layout-menu-container-b');
        elMenuContainer.classList.add('layout-menu-container-h');
        elMenuHorizontal.append(elMenuContainer);
        elDivPanel.style.height = 'calc(100vh - 140px)';
        elDivPanel.style.transition = 'height 0.5s ease 0s !important';
        setTextoMenu('Horizontal');
        elMenuHorizontal.removeAttribute('style');
        animeMenu(elMenuContainer);
      }

      if (countPosition === 2) {
        elMenuHorizontal.style.opacity = '0';
        elMenuContainer.style.marginBottom = '0';
        elMenuHorizontal.style.position = 'absolute';
        elMenuHorizontal.style.zIndex = '9999';
        elMenuHorizontal.style.bottom = '0';
        elMenuHorizontal.style.width = '100%';
        elMenuContainer.classList.remove('layout-menu-container-h');
        elMenuContainer.classList.add('layout-menu-container-b');
        setTextoMenu('Bottom');
        animeMenu(elMenuHorizontal);
      }

    } catch (ex) {
      console.log(ex);
    }
  }

  const onChangeOptioDropdownMobile = (side) => {
    try {
      document.querySelector(`[data-cy=side-panel-header-${side}]`).click();
    } catch (ex) { }
  }

  const optionsDropdownMobile = [
    {
      name: 'Estudos',
      onClick: () => onChangeOptioDropdownMobile('left')
    },
    {
      name: 'Segmentação',
      onClick: () => onChangeOptioDropdownMobile('right')
    },
    {
      name: 'Medidas',
      onClick: () => onChangeOptioDropdownMobile('right')
    },
    {
      name: 'Laudo',
      onClick: () => onChangeOptioDropdownMobile('right')
    },
  ];

  const onChangeOptionsMobile = (value) => {
    setSelectedOptionMobile(value);
  }

  useEffect(() => {
    if (selectedOptionMobile) {
      selectedOptionMobile.onClick();
    }
  }, [selectedOptionMobile])

  const menuStartMobile = <div style={{ display: 'flex' }}>
    <Button id='btnOptionMobile' label='' icon='pi pi-list' className="p-button-text" style={{ marginLeft: '5px' }} />
    {window.isMobile() && !autenticado
      ? <Button
        id="btnEstudosMobile"
        label='Estudos'
        icon='pi pi-eye'
        className="p-button-text"
        onClick={() => onChangeOptioDropdownMobile('left')}
      />
      :
      <DropdownPF
        value={selectedOptionMobile}
        onChange={(e) => onChangeOptionsMobile(e.value)}
        optionLabel='name'
        placeholder='Opções'
        dropdownIcon='pi pi-eye'
        options={optionsDropdownMobile}>
      </DropdownPF>
    }
  </div>

  const menuStart = window.isMobile() ? menuStartMobile : <div style={{ display: 'flex' }}>
    <a href={window.location.origin}><img alt="logo" src="/layout/logo.png" style={{ maxHeight: '40px' }} className="p-mr-2"></img></a>
    <Dropdown id="options" size="150px" showDropdownIcon={false} list={optionsMenuHeader}>
      <IconButton
        id={'options-settings-icon'}
        variant="text"
        color="inherit"
        className="text-primary-active"
      >
        <Icon name="menu-top" />
      </IconButton>
    </Dropdown>
  </div>

  const menuEnd = <div>
    <div className="flex items-center">{children}</div>
    <Button
      label={<div className='flex'>
        <Icon name={`align-menu-${textoMenu.toLowerCase()}`} style={{ width: '20px', height: '20px' }} />
        <div style={{ marginLeft: '10px' }}>Posição do Menu</div>
      </div>}
      onChange={(e) => setValue(e.value)}
      style={{ display: window.isMobile() || !isReturnEnabled ? 'none' : '' }}
      tooltipOptions={{ 'position': 'bottom' }}
      onClick={(e) => startPositionMenu(e)}
      className="p-button-text"
    >
    </Button>

    <Button
      label={`Fechar${window.isMobile() === false ? ' Exame' : ''}`}
      icon="pi pi-times"
      className="p-button-text"
      onClick={() => FecharExame()}
      style={{ display: sessionStorage.getItem('auth') && acessoViewer ? '' : 'none' }}
    />
    <Button
      style={{ marginLeft: '8px' }}
      label='Sair'
      icon="pi pi-sign-out"
      className="p-button-text"
      onClick={() => setDialogConfirmacao(true)}
    />
  </div>;

  const renderFooter = <div style={{ textAlign: 'right' }}>
    <Button label="Sim" icon="pi pi-check" onClick={() => sair()} autoFocus />
    <Button label="Não" icon="pi pi-times" onClick={() => setDialogConfirmacao(false)} className="p-button-text" />
  </div>

  const sair = () => {
    if (sessionStorage.getItem('auth')) {
      sessionStorage.clear();
      sessionStorage.setItem('redirectUser', '1');
    } else {
      sessionStorage.setItem('redirectMsg', '1');
    }
    setTimeout(() => {
      window.location.href = window.location.origin;
    }, 500);
  }

  const FecharExame = () => {
    window.history.go(-1);
  }

  // TODO: this should be passed in as a prop instead and the react-router-dom
  // dependency should be dropped
  const onClickReturn = () => {
    if (isReturnEnabled && onClickReturnButton) {
      onClickReturnButton();
    }
  };

  return (
    <>
      <Dialog
        header="Sobre"
        visible={dialogSobre}
        style={{ width: isMobile ? '80vw' : '40vw' }}
        onHide={() => setDialogSobre(false)}
        draggable={false}
        resizable={false}
      >
        <p><strong>Tzion WebViewer</strong></p>
        <p>O Tzion WebViewer possui funcionalidades avançadas como manipulação de imagem (panorâmica, zoom, janelas, predefinições, rotação, flip, rolagem, mira, filtragem), comparação de séries ou estudos, sincronização em série, reconstruções multiplanares e projeção de intensidade máxima entre outras funcionalidades que permitem um diagnóstico por imagem ainda mais assertivo.</p>
        <br></br>
        <div className='flex'>
          <div>
            <img alt="logo" src="/assets/logo-asl.png" width="85" height="85"></img>
          </div>
          <div style={{ marginLeft: '30px' }}>
            ASL SOFTHOUSE<br></br>
            Contato: +55 21 2742 8080<br></br>
            <a href="https://aslsofthouse.com.br">https://aslsofthouse.com.br</a> <br></br>
            <a href="mailto:contato@aslsofthouse.com.br">contato@aslsofthouse.com.br</a>
          </div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <br></br>
          <p>{window.config.versao}</p>
        </div>
      </Dialog>

      <Dialog
        header="Confirmação"
        visible={dialogConfirmacao}
        style={{ width: '25vw' }}
        //footer={renderFooter}
        position={'top'}
        onHide={() => setDialogConfirmacao(false)}
        draggable={false}
        resizable={false}
      >
        <br></br>
        <div style={{ textAlign: 'center' }}><p>Tem certeza que deseja sair da aplicação?</p></div><br></br>
        <br></br>
        {renderFooter}
      </Dialog >

      <Menubar
        model={[]}
        start={menuStart}
        end={menuEnd}
        style={{ border: 'none', borderRadius: '0', background: '#040d19' }}
      ></Menubar>

    </>

  );
}

Header.propTypes = {
  menuOptions: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.string,
      onClick: PropTypes.func.isRequired,
    })
  ),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  isReturnEnabled: PropTypes.bool,
  isSticky: PropTypes.bool,
  onClickReturnButton: PropTypes.func,
  WhiteLabeling: PropTypes.object,
};

Header.defaultProps = {
  isReturnEnabled: true,
  isSticky: false,
};

export default Header;
